<template>
  <div class="c-store-vacation-info">
    <div class="c-store-vacation-info__icon is-active">
      <img
        class="c-store-vacation-info__img"
        :src="require('@@/assets/images/web/pages/products/new/vacation.svg')"
        loading="lazy"
      >
    </div>

    <!-- eslint-disable vue/no-v-html -->
    <p
      v-if="message"
      class="o-text -md-long-primer -xs-brevier -xs-normal c-store-vacation-info__text"
      v-html="message"
    />
    <!-- eslint-enable -->

    <p
      v-else
      class="o-text -md-long-primer -xs-brevier -xs-normal c-store-vacation-info__text"
    >
      loja de folga. para voltar a vender e publicar novos anúncios você precisa ativá-la antes.
    </p>

    <a
      v-if="shouldShowButton"
      href="/perfil/alterar"
      class="o-button -xs-secondary -xs-small -xs-fill -xs-flat c-store-vacation-info__cta"
    >
      ativar loja
    </a>
  </div>
</template>

<script>
  export default {
    props: {
      message: {
        type: String,
        default: ''
      },
      shouldShowButton: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang="scss">
  .c-store-vacation-info {
    display: block;
    max-width: 350px;
    margin: 100px auto;
    text-align: center;

    &__icon {
      position: relative;
      display: block;
      width: 50px;
      margin: 0 auto 20px;

      &.is-active {
        &::after {
          content: '';
          position: absolute;
          top: -6px;
          right: 1px;
          width: 16px;
          height: 16px;
          background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGZpbGw9IiNGMDVCNzgiIGN4PSI4IiBjeT0iOCIgcj0iOCIvPjxwYXRoIGQ9Ik02LjUgOS43OTNsNC42NDYtNC42NDdhLjUuNSAwIDExLjcwOC43MDhsLTUgNWEuNS41IDAgMDEtLjcwOCAwbC0yLTJhLjUuNSAwIDExLjcwOC0uNzA4TDYuNSA5Ljc5M3oiIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIvPjwvZz48L3N2Zz4=);
        }
      }
    }

    &__text {
      display: block;
      margin: 0 auto 30px;

      @include breakpoint($until: md) {
        margin-bottom: 15px;
      }
    }

    &__cta {
      display: block;
      margin: 0 auto;
      max-width: 170px;

      @include breakpoint($until: md) {
        max-width: 120px;
      }
    }
  }
</style>
